import { RoutesE } from './../../../routes/routesData';

export const getItemIdForProductTour = (link: RoutesE) => {
    if (link === RoutesE.CAMPAIGNS) return 'campaigns-menu-item';
    if (link === RoutesE.DELIVERIES) return 'deliveries-menu-item';
    if (link === RoutesE.SETTINGS) return 'settings-menu-item';
    return undefined;
};